import React, { useMemo } from 'react';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import { useAITTheme, type AITTheme } from '@this/shared/ui/theme';

const CalendarConnectionBadge = () => {
  const { theme } = useAITTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);

  return (
    <span style={styles.badge} title="Googleカレンダー連携済み" aria-label="Googleカレンダー連携済み">
      <CalendarTodayIcon style={styles.icon} />
    </span>
  );
};

const getStyles = (theme: AITTheme) => ({
  badge: {
    display: 'inline-flex',
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
    minWidth: '32px',
    height: '32px',
    padding: '0 8px',
    borderRadius: '16px',
    backgroundColor: '#eef6eb',
    border: `1px solid ${theme.grayBorderColor}`
  },
  icon: {
    fontSize: '16px',
    color: '#2f7d32'
  }
});

export default CalendarConnectionBadge;
